var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!this.$store.getters.isAuthenticated)?_c('header-before-login'):_vm._e(),(this.$store.getters.isAuthenticated)?_c('header-after-login'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }